import { useState } from 'react';
import { Button, Modal, ModalFooter, ModalTitle } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import { SocialMediaShare } from 'src/common/components';
import { useTrackEventMutation } from 'src/common/slices/analytics';
import { Role } from 'src/features/skills-matrix/skills-matrix.types';
import { SkillMatrixSegment } from 'src/common/components/skill-matrix-graphic/skill-matrix-graphic.types';
import { StyledContentWrapper, StyledShareSection, StyledSkillsMatrixImage, StyledSkillsMatrixPlaceholder } from './share-skills-modal.styles';
import { useGetSkillsMatrixImageQuery } from './share-skills-modal.slice';
export const ShareSkillsModal = ({
  role,
  segment
}: {
  role: Role;
  segment: SkillMatrixSegment;
}) => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [trackEvent] = useTrackEventMutation();
  const toggleShareModal = () => {
    if (!isPopUpOpen) {
      // eslint-disable-next-line no-void
      void trackEvent({
        event: 'click-share-preview',
        properties: {
          name: `${segment}-${role.toLowerCase().replace(' ', '-')}-skills-matrix`,
          certificate_type: `skills-matrix`
        }
      });
    }
    setIsPopUpOpen(!isPopUpOpen);
  };
  const {
    data,
    isLoading
  } = useGetSkillsMatrixImageQuery({
    role,
    segment
  }, {
    skip: !isPopUpOpen
  });
  const imageUrl = data?.data;
  const shareId = imageUrl?.split('/').pop()?.replace('.png', '');
  const shareUrl = shareId ? `${process.env.ENV_URL ?? 'https://tryhackme.com'}/share/skills-matrix/${shareId}` : '';
  return <Modal onOpenChange={toggleShareModal} open={isPopUpOpen} triggerElement={<Button color="add">
          <FontAwesomeIcon icon={faShare} />
          Share
        </Button>} data-sentry-element="Modal" data-sentry-component="ShareSkillsModal" data-sentry-source-file="share-skills-modal.tsx">
      <ModalTitle data-sentry-element="ModalTitle" data-sentry-source-file="share-skills-modal.tsx">Share your skills matrix</ModalTitle>
      <StyledContentWrapper data-sentry-element="StyledContentWrapper" data-sentry-source-file="share-skills-modal.tsx">
        <p>Share your skill matrix with your friends and your network! Stand out amongst the crowd!</p>
        {isLoading ? <StyledSkillsMatrixPlaceholder /> : <StyledSkillsMatrixImage src={imageUrl} alt="Skills Matrix" />}
      </StyledContentWrapper>
      <StyledShareSection data-sentry-element="StyledShareSection" data-sentry-source-file="share-skills-modal.tsx">
        <p>Share this with your friends:</p>
        <SocialMediaShare showTitle={false} isBig pageUrl={shareUrl} shareDescription="Check out my skills:" data-sentry-element="SocialMediaShare" data-sentry-source-file="share-skills-modal.tsx" />
      </StyledShareSection>
      <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="share-skills-modal.tsx">
        <Button variant="outlined" color="secondary" onClick={() => setIsPopUpOpen(false)} data-sentry-element="Button" data-sentry-source-file="share-skills-modal.tsx">
          Close
        </Button>
      </ModalFooter>
    </Modal>;
};